// @flow

import { newConfigurationPageActions } from './newConfigurationPageActionCreator';

const initialState = {
  fetching: null,
  fetched: null,
  filesUrl: null
};

const newConfigurationPageReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case newConfigurationPageActions.GET_FILE_URLS: {
      return Object.assign({}, state, action.payload);
    }

    case newConfigurationPageActions.SAVE_NETWORK_CONFIG: {
      return Object.assign({}, state, action.payload);
    }

    case newConfigurationPageActions.RUN_CONFIGURATION: {
      return Object.assign({}, state, action.payload);
    }

    case newConfigurationPageActions.GET_CONFIGS_WITH_ID: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
};

export default newConfigurationPageReducer;
